import { Image } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledQuote from './Quote.style.js';

const Quote = ({
  author,
  externalAuthor,
  quote,
  linkTo,
  className,
  isHero
}) => {
  const authorUser = author[0] || null;
  return /*#__PURE__*/React$1.createElement(StyledQuote, {
    className: className,
    hasPhoto: Boolean(author[0] && author[0].photo),
    isHero: isHero
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "quote__wrapper"
  }, /*#__PURE__*/React$1.createElement(Grid$1, null, authorUser && authorUser.photo && isHero && /*#__PURE__*/React$1.createElement("div", {
    className: "quote__author-image-wrapper"
  }, /*#__PURE__*/React$1.createElement(Image, _extends({}, authorUser.photo, {
    ratio: "1:1",
    className: "quote__author-image"
  }))), /*#__PURE__*/React$1.createElement("div", {
    className: "quote__content"
  }, isHero ? /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "quote",
    className: "quote__icon"
  }, "\u201C"), /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "p",
    variant: "quote",
    className: "quote__text"
  }, quote)) : /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "p",
    variant: "quote",
    className: "quote__text"
  }, "\u201E", quote, "\u201C")), /*#__PURE__*/React$1.createElement("div", {
    className: "quote__author"
  }, authorUser ? /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "cite",
    variant: "copy"
  }, authorUser.fullName, authorUser.position && `, ${authorUser.position}`) : /*#__PURE__*/React$1.createElement(React$1.Fragment, null, linkTo && linkTo.url && /*#__PURE__*/React$1.createElement("cite", null, /*#__PURE__*/React$1.createElement(Link$1, {
    href: linkTo.url,
    target: linkTo.target,
    icon: linkTo.target === '_blank' ? 'external' : null,
    type: "secondary",
    variant: "copy",
    component: "a"
  }, linkTo.type === 'url' ? externalAuthor || linkTo.customText || linkTo.url : linkTo.customText || linkTo.text)), !linkTo.url && externalAuthor && /*#__PURE__*/React$1.createElement("cite", null, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "cite",
    variant: "copy"
  }, externalAuthor)))))));
};

Quote.propTypes = {
  externalAuthor: PropTypes$1.string,
  author: PropTypes$1.arrayOf(PropTypes$1.shape({
    fullName: PropTypes$1.string,
    position: PropTypes$1.string,
    photo: PropTypes$1.shape({
      url: PropTypes$1.string
    })
  })),
  linkTo: PropTypes$1.shape({
    type: PropTypes$1.string,
    text: PropTypes$1.string,
    customText: PropTypes$1.string,
    url: PropTypes$1.string,
    target: PropTypes$1.string
  }),
  quote: PropTypes$1.string.isRequired,
  className: PropTypes$1.string,
  isHero: PropTypes$1.bool
};
Quote.defaultProps = {
  externalAuthor: null,
  author: [],
  linkTo: null,
  className: '',
  isHero: false
};

export default Quote;
